module.exports = __webpack_public_path__ + "static/media/sound_icon.503452e0.svg";